import * as actionTypes from "./contractTypes";

const INITIAL_STATE = {
    contractList: [],
};

const contractReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETCONTRACTLIST:
            return {
                ...state,
                contractList: action.payload.list,
            };
        default:
            return state;
    }
};

export default contractReducer;